/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Account nav dropdown

const accountButton = document.querySelector('#account-button');
const accountDropDown = document.querySelector('#accountNav');
accountDropDown.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    removeTrapFocus(accountDropDown);
    accountDropDown.classList.add('hidden');
    accountButton.setAttribute('aria-expanded', 'false');
  }
})

accountButton?.addEventListener("click", e => {
  trapFocus(accountDropDown);
  if (accountDropDown.classList.contains('hidden')) {
    accountDropDown.classList.remove('hidden');
    accountButton.setAttribute('aria-expanded', 'true');
  } else {
    accountDropDown.classList.add('hidden');
    accountButton.setAttribute('aria-expanded', 'false');
  }
});

// JS for account login/register forms
const loginButton = document.querySelector('.nav-tabs__login');
const registerButton = document.querySelector('.nav-tabs__register');
const loginForm = document.querySelector('#login');
const registerForm = document.querySelector('#register');
const forgotPassBtn = document.querySelector('.forgot-password-btn');
const forgotPassForm = document.querySelector('#recover_customer_password');

if (loginButton) {
  loginButton.addEventListener("click", e => {
    registerForm.classList.add('hidden');
    loginForm.classList.remove('hidden');
    loginButton.classList.add('nav--underline');
    registerButton.classList.remove('nav--underline');
    forgotPassForm.classList.add('hidden');
  });
}
if (registerButton) {
  registerButton.addEventListener("click", e => {
    registerForm.classList.remove('hidden');
    loginForm.classList.add('hidden');
    loginButton.classList.remove('nav--underline');
    registerButton.classList.add('nav--underline');
    forgotPassForm.classList.add('hidden');
  });
}
if (forgotPassBtn) {
  forgotPassBtn.addEventListener("click", e => {
    forgotPassForm.classList.remove('hidden');
    loginForm.classList.add('hidden');
  });
}


const topFilters = document.querySelectorAll('.Collapsible__FiltersOnTop')
for (const filter of topFilters) {
  filter.addEventListener('mouseleave', e => {

    var toggleButton = filter.querySelector('.Collapsible__Button'),
      collapsibleInner = filter.querySelector('.Collapsible__Inner');

    if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'false') {
      return; // It's already closed
    }

    toggleButton.setAttribute('aria-expanded', 'false');
    collapsibleInner.style.overflow = 'hidden';

  })
}

window.onload = function () {

  const sortbyButton = document.getElementById('Sortby__Button');
  const flickityNext = document.querySelectorAll('.flickity-prev-next-button[disabled]');



  document.addEventListener('focusin', function () {

    // find open navmenu  openMenu
    let openMenu = document.querySelector('.Header__MainNav .HorizontalList__Item.is-expanded[aria-haspopup]');
    //const el =
    if (openMenu != null) {
      if (!openMenu.contains(document.activeElement)) {

        let megaMenu = openMenu.querySelector('[aria-hidden="false"]');

        if (megaMenu) {
          megaMenu.ariaHidden = "true"
        }

      }
    }

  }, true);




  if (sortbyButton) {

    sortbyButton.addEventListener('click', e => {

      const focusElement = document.getElementById('collection-sort-popover').querySelector('.is-selected');
      setTimeout(function () { focusElement.focus(); }, 100);

    });

  }



  document.getElementById('mobile-sidebar-button').addEventListener('click', e => {
    setTimeout(function () {

      document.getElementById('mobile-sidebar-close').focus();
    }, 100);
    document.getElementById('mobile-sidebar-close').focus();
  });


}

// window.onload = function() {

//   const tagContainer = document.getElementById('currentTags');
//   console.log(tagContainer);
//   tagContainer.addEventListener('click', e => {
//     console.log(e.target.closest('button'));


//     // var toggleButton = filter.querySelector('.Collapsible__Button'),
//     // collapsibleInner = filter.querySelector('.Collapsible__Inner');

//     // if (!collapsibleInner || toggleButton.getAttribute('aria-expanded') === 'false') {
//     //     return; // It's already closed
//     //     }

//     // toggleButton.setAttribute('aria-expanded', 'false');
//     // collapsibleInner.style.overflow = 'hidden';
//    });

// };
function isSafari() {
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.indexOf('safari') != -1) {
    if (userAgent.indexOf('chrome') > -1) {
      return false; //chrome
    } else {
      return true; //safari
    }
  } else {
    return false;
  }
}

/* tested on the iPad and iPhone */
function getSafariZoomFactor() {
  var deviceWidth, landscape = Math.abs(window.orientation) == 90
  // workaround for strange screen.height on the iPhone (v3.1.3)
  if (window.screen.width == 320) deviceWidth = landscape ? 480 : 320
  else deviceWidth = window.screen[landscape ? "height" : "width"]
  return deviceWidth / window.innerWidth
}

const removeZoomLevelClasses = () => {
  const bodyClass = document.body.className.split(' ').filter(el => el.toLowerCase().indexOf('zoom-level-') === -1).join(' ');
  document.body.className = bodyClass
}

const updateZoomLevel = () => {
  removeZoomLevelClasses()

  let zoomLevel = window.devicePixelRatio;

  if (isSafari()) {
    zoomLevel = parseInt(getSafariZoomFactor()) * 2;
  }

  if (zoomLevel >= 5) {
    if (zoomLevel >= 8) {
      document.documentElement.classList.add(`zoom-level-over-8`)
    } else {
      document.documentElement.classList.add(`zoom-level-${zoomLevel}`)
    }
  }
}

const getAllProducts = (target, url) => {
  fetch(url, {
    credentials: 'same-origin',
    method: 'GET'
  }).then((content) => {
    content.text().then(function (html) {
      var tempElement = document.createElement('div');
      tempElement.innerHTML = html;
      var ProductList = tempElement.querySelector('.ProductList');
      if (target) {
        target.innerHTML = ProductList.innerHTML
      }
    });
  })
}

const updateHeaderonPDP = () => {
  if (document.body.classList.contains('template-product')) {
    const header = document.querySelector('#section-header')
    if (window.innerWidth <= 1007) {
      document.body.classList.add('has-transparent-header');
      header && header.classList.add('Header--transparent')
      document.documentElement.style.setProperty('--header-is-not-transparent', 0);
      document.documentElement.style.setProperty('--header-is-transparent', 1);

      if (window.pageYOffset <= 10) {
        header && header.classList.add('Header--transparent');
      } else {
        header && header.classList.remove('Header--transparent');
      }
    } else {
      document.body.classList.remove('has-transparent-header');
      header && header.classList.remove('Header--transparent')
      document.documentElement.style.setProperty('--header-is-not-transparent', 1);
      document.documentElement.style.setProperty('--header-is-transparent', 0);
    }
  }
}

window.addEventListener('scroll', () => {
  updateHeaderonPDP();
})

window.addEventListener('resize', () => {
  updateZoomLevel();
  updateHeaderonPDP();
})

document.addEventListener('DOMContentLoaded', () => {
  updateZoomLevel();
  const viewAllProductButton = document.querySelector('[data-js-view-all-products]');
  if (viewAllProductButton) {
    viewAllProductButton.addEventListener('click', () => {
      const url = event.target.dataset.url;
      const target = document.querySelector('.ProductList');
      getAllProducts(target, url);
    })
  }

  const PageSkipLink = document.querySelector('.PageSkipLink');
  if (PageSkipLink) {
    PageSkipLink.addEventListener('click', (e) => {
      // e.preventDefault();
      const mainContent = document.querySelector('#main');
      if (mainContent) {
        mainContent.focus()
      }
    })
  }
  updateHeaderonPDP();
})



// Global E Popup

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
      scrollContainer: this.closest('.Drawer__Main'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.handleDocumentClick = (e) => {
      if (!document.body.contains(e.target)) return;

      if (this.isOpen && !this.contains(e.target)) {
        this.hidePanel();
      }
    };

    document.addEventListener("click", this.handleDocumentClick);

    this.addEventListener('click', (e) => {
      if (e.target.closest('[data-close]')) {
        this.hidePanel();
        return;
      }

      if (!e.target.closest('a')) return;

      this.onItemClick(e);
    });
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
    this.isOpen = false;
    if (this.elements.scrollContainer) {
      this.elements.scrollContainer.style.overflow = null;
      disableBodyScroll(true, '[data-scrollable]');
      this.elements.button.scrollIntoView();
    }
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.target.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.isOpen = true;
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    if (this.elements.scrollContainer) {
      this.elements.scrollContainer.scrollTo({ top: 0 });
      this.elements.scrollContainer.style.overflow = 'hidden';
      // disableBodyScroll only supports one scrollable container so we need to disable
      // so the disclosure list can be scrolled
      disableBodyScroll(false);
    }
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);

// Announcement Banner
const initAnnouncementBanner = () => {
  const banner = document.querySelector('[data-announcement-banner]')
  if (!banner) return;
  const { delay } = banner.dataset || 2500;
  const swiper = new Swiper(banner, {
    loop: true,
    centeredSlides: true,
    autoplay: {
      delay: parseFloat(delay) * 1000,
      disableOnInteraction: false,
      pauseOnMouseEnter: false
    },
    // Navigation arrows
    navigation: {
      nextEl: banner.querySelector('.swiper-button-next'),
      prevEl: banner.querySelector('.swiper-button-prev'),
    },
  });
}


// Registration Page
class Storefront {
  constructor() {
    this.headers = {
      "X-Shopify-Storefront-Access-Token": window.storefront.api_token,
      "Content-Type": "application/json",
    };
  }

  request = async ({ query, variables = {} }) => {
    if (!window.storefront.api_token || !window.storefront.api_url) {
      console.error("There was an error with the storefront token.");
      return undefined;
    }

    const response = await fetch(
      `${window.storefront.api_url}`,
      {
        headers: this.headers,
        method: "POST",
        body: JSON.stringify({
          query,
          variables,
        }),
      }
    );
    return await response.json();
  };
}

const handleCreateCustomer = async (e) => {
  const form = e.target.closest('form');
  const formData = new FormData(form);

  if (formData.get('customer[email]') == '' || formData.get('customer[password]') == '') {
    return;
  } else {
    if (formData.get('customer[phone]') == '') return;
    e.preventDefault();
    const acceptsMarketingElem = form.querySelector('[name="customer[accepts_marketing]"]')
    let acceptsMarketing = false;
    if (acceptsMarketingElem) {
      acceptsMarketing = acceptsMarketingElem.checked
    }

    const storefront = new Storefront();
    const query = `
      mutation customerCreate($input: CustomerCreateInput!) {
        customerCreate(input: $input) {
          customer {
            firstName
            lastName
            email
            phone
            acceptsMarketing
          }
          customerUserErrors {
            field
            message
            code
          }
        }
      }
    `;

    const variables = {
      "input": {
        "firstName": formData.get('customer[first_name]'),
        "lastName": formData.get('customer[last_name]'),
        "email": formData.get('customer[email]'),
        "phone": formData.get('customer[phone]'),
        "password": formData.get('customer[password]'),
        "acceptsMarketing": acceptsMarketing
      }
    }
    const response = await storefront.request({
      query: query,
      variables: variables
    });

    const handleErrorValidation = (message) => {
      const formErrorElement = form.querySelector('.Form__Alert');
      if (formErrorElement) {
        formErrorElement.innerHTML = message;
      } else {
        const formItem = form.querySelector('.Form__Item');
        const errorDiv = document.createElement("div");
        errorDiv.classList.add('Form__Alert', 'Alert', 'Alert--error');
        errorDiv.innerHTML = message;

        form.insertBefore(errorDiv, formItem)
      }
    }

    if (response?.data?.customerCreate) {
      if (response?.data?.customerCreate?.customer != null) {
        console.log(response.data.customerCreate);
        const loginForm = document.querySelector('#customer_login');
        const emailElement = loginForm.querySelector('[name="customer[email]"]');
        const passwordElement = loginForm.querySelector('[name="customer[password]"]');
        if (emailElement && passwordElement) {
          emailElement.value = formData.get('customer[email]')
          passwordElement.value = formData.get('customer[password]')
          loginForm.submit();
        }
      } else {
        if (response?.data?.customerCreate?.customerUserErrors) {
          const message = response?.data?.customerCreate?.customerUserErrors[0].message;
          handleErrorValidation(message);
        } else {
          handleErrorValidation("Something went wrong, please try again!")
        }
      }
    } else {
      handleErrorValidation("Something went wrong, please try again!")
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const createButton = document.querySelector('#create_customer [type="submit"]');
  if (createButton) {
    createButton.addEventListener('click', e => handleCreateCustomer(e))
  }

  window.addEventListener('click', (evt) => {
    if (evt.target.classList.contains('PageOverlay') || evt.target.closest('.PageOverlay')) {
      const wrap = document.querySelector('.pdp-sticky-atc')
      wrap && wrap.classList.remove('active');
      evt.target.classList.remove('is-visible')
    }
  });

  window.addEventListener('click', (evt) => {
    if (evt.target.hasAttribute('data-pdp-sticky-form-show') || evt.target.closest('[data-pdp-sticky-form-show]')) {
      const overlay = document.querySelector('.PageOverlay')
      const wrap = document.querySelector('.pdp-sticky-atc')
      wrap && wrap.classList.add('active');
      overlay && overlay.classList.add('is-visible');
    }
  });
  var swipe_close = document.querySelector('.atc-popup-swipe-btc');
  var pdp_sticky_atc = document.querySelector('.pdp-sticky-atc');
  var sticky_touchstart = null;
  var sticky_touchend = null;
  if (pdp_sticky_atc) {
    if (swipe_close) {
      swipe_close.addEventListener('touchstart', e => {
        sticky_touchstart = e.targetTouches[0].clientY;
        sticky_touchend = null;
      });

      swipe_close.addEventListener('touchmove', (e) => {
        sticky_touchend = e.targetTouches[0].clientY;
        console.log(Math.min(0, sticky_touchstart - sticky_touchend));
        pdp_sticky_atc.style.marginBottom = Math.min(0, sticky_touchstart - sticky_touchend) + 'px';
      });

      swipe_close.addEventListener('touchend', () => {
        console.log(sticky_touchend - sticky_touchstart);
        if (sticky_touchend & ((sticky_touchend - sticky_touchstart) > 50)) {
          pdp_sticky_atc && pdp_sticky_atc.classList.remove('active');
          document.querySelector('.PageOverlay').classList.remove('is-visible');
          pdp_sticky_atc.style.marginBottom = 0;
        }
        else {
          pdp_sticky_atc.style.marginBottom = 0;
        }
      });
    }
  }
  initAnnouncementBanner()
})

class TabComponent extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = [...this.querySelectorAll('[data-action="toggle-tab"]')];
    this.init();
  }

  init() {
    this.tabButtons.map((button) => {
      button.addEventListener('click', this._switchTab.bind(this))
    })
  }

  _switchTab(event) {
    // If the tab is already active, do nothing
    if (event.target.classList.contains('is-active')) {
      return;
    }

    // First, switch the current tab
    event.target.classList.add('is-active');
    this.getSiblings(event.target, '.is-active').forEach(function (item) {
      item.classList.remove('is-active');
      item.setAttribute('aria-selected', 'false');
    });
    event.target.setAttribute('aria-selected', 'true');

    // Then, display the panel
    var tabPanelToShow = this.querySelector('#' + event.target.getAttribute('aria-controls'));
    tabPanelToShow.setAttribute('aria-hidden', 'false');

    this.getSiblings(tabPanelToShow, '.TabPanel[aria-hidden="false"]').forEach(function (item) {
      item.setAttribute('aria-hidden', 'true');
    });
  }

  getSiblings(element, filter) {
    var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var siblings = [];
    var currentElement = element;

    // Do the previous first
    while (currentElement = currentElement.previousElementSibling) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    if (includeSelf) {
      siblings.push(element);
    }

    // Then the next side
    currentElement = element;

    while (currentElement = currentElement.nextElementSibling) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    return siblings;
  }
}
if (!customElements.get('tab-component')) {
  customElements.define('tab-component', TabComponent);
}


class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      document.querySelector('#ShopifyChat').style.zIndex = 1;
      document.querySelector('.needsclick').style.zIndex = 1;
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    if (document.querySelector('#ShopifyChat'))
      document.querySelector('#ShopifyChat').style.zIndex = 9999;
    document.querySelector('.needsclick').style.zIndex = 9999;
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

document.addEventListener("DOMContentLoaded", (event) => {
  var footer_menus = document.querySelectorAll('.Footer__Block--section.Footer__Menu .Footer__Title');
  footer_menus.forEach((el) => el.addEventListener('click', function () {
    console.log(el);
    el.classList.toggle('active');
    el.setAttribute('aria-expanded', el.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
  }));
});
